export default __webpack_public_path__ + "static/media/LUX_SORPRENDIDA.b8e16c6f.png";